<template>
  <nav v-if="hasTagLinks"
       class="article-tags-navigation">
    <ul>
      <li v-for="tag in tagLinks"
          :key="tag.key">
        <a :href="tag.href">
          {{ tag.label }}
        </a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "ArticleTags",
  props: {
    redirectUrl: {
      type: String,
      default: null,
    },
    tags: {
      type: Object,
      default: () => ( {} ),
      validator: ( val ) => Object.keys( val ).every( key => Array.isArray( val[key] ) ),
    },
  },
  computed: {
    hasTagLinks () {
      return this.isArrayWithAny( this.tagLinks );
    },
    tagLinks () {
      let result = [];

      if ( this.tags ) {
        result = Object.keys( this.tags ).map( key => this.tags[key].map( ( str, idx ) => ( {
          label: str,
          href: this.createTagLink( { key, value: str } ),
          key: this.generateHashCode( `${idx}:${key}:${str}` ),
        } ) ) ).flat();
      }

      return result;
    },
  },
  methods: {
    isArrayWithAny ( arr ) {
      return Array.isArray( arr ) && arr.length > 0;
    },
    createTagLink ( query ) {
      let result = "#";

      if ( this.redirectUrl ) {
        try {
          const baseUrl = this.redirectUrl.includes( window.location.host )
            ? null
            : `${window.location.origin}`;

          const url = new URL( this.redirectUrl, baseUrl );

          if ( url && typeof url.searchParams?.append === "function" ) {
            const { key, value } = query;
            url.searchParams.append( key, value );
            result = url.href;
          }
        } catch ( err ) {
          console.error( err );
        }
      }
      return result;
    },
    generateHashCode ( str ) {
      let hash = 0;

      for ( let i = 0, len = str.length; i < len; i += 1 ) {
        const chr = str.charCodeAt( i );
        // eslint-disable-next-line no-bitwise
        hash = ( hash << 5 ) - hash + chr;
        // eslint-disable-next-line no-bitwise
        hash |= 0;
      }
      return hash;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../Styles/utils/colors.less";
.article-tags-navigation {
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;

    li {
      border: 1px solid @color-accent-1;
      padding: 0 7px;
      border-radius: 12px;
      background-color: @color-accent-1;

      &:hover {
        border: 1px solid @color-accent-1;
        background-color: #fff;

        a {
          color: @color-accent-1;
        }
      }

      a {
        color: #fff;
        font-weight: 300;
        text-decoration: none;
      }
    }
  }
}

</style>
